// ======================================================================
// File Name       : MultiLanguageResultDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { LINE_SEPARATOR, PROCESS_STATUS } from '../../constants/ContentConstant';
import { parseDateForDetail, replaceAllLineBreakWithHTMLTag } from '../../utils';
import { changeMultiLanguageProcessResultStatus, changeMultiLanguageProcessStatus, convertLanguageName } from '../../utils/ContentUtils';

class MultiLanguageResultDetail extends React.Component {

  render() {
    const {
        multiLanguageProcessManagementIdAuto,
        processStatus,
        processType,
        processStartTime,
        languageCode,
        documentInfo,
        errorList,
    } = this.props.multiLanguageProcessResultInfo;

    return (
      <div>
        <Form className='form-horizontal'>
          {processStatus === PROCESS_STATUS.FAILED && errorList ? (
            <Col sm={12}>
              <Form.Group className="message-error">
                {
                  replaceAllLineBreakWithHTMLTag(errorList, LINE_SEPARATOR).split(LINE_SEPARATOR).map((err, index) =>
                    (<p key={index} className="padding-top-10">{err}</p>))
                }
              </Form.Group>
            </Col>
          ) : null}
          <Col sm={12}>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>処理ID</Col>
              <Col as={Form.Label} sm={7}>{multiLanguageProcessManagementIdAuto}</Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>処理種別</Col>
              <Col as={Form.Label} sm={7}>{changeMultiLanguageProcessResultStatus(processType)}</Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                処理開始日時
              </Col>
              <Col as={Form.Label} sm={7}>{parseDateForDetail(processStartTime)}</Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                処理結果
              </Col>
              <Col as={Form.Label} sm={7}>{changeMultiLanguageProcessStatus(processStatus)}</Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                言語
              </Col>
              <Col as={Form.Label} sm={7}>{convertLanguageName(languageCode)}</Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コンテンツ識別ID
              </Col>
              <Col as={Form.Label} sm={7}>{documentInfo.contentSecernId}</Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コンテンツ名
              </Col>
              <Col as={Form.Label} sm={7}>{documentInfo.contentName}</Col>
            </Form.Group>
          </Col>
        </Form>
      </div>
    );
  }
}

export default MultiLanguageResultDetail;
